import React from 'react';
import { SportsFootball, SportsBasketball } from '@mui/icons-material';
import { Sport } from '../types';

/**
 * Get the appropriate icon component for a sport
 */
export const getSportIcon = (sport: Sport) => {
  switch (sport) {
    case 'football':
      return SportsFootball;
    case 'basketball':
      return SportsBasketball;
    default:
      return SportsFootball; // Default fallback
  }
};

/**
 * Render a sport icon as a React element
 */
export const SportIcon: React.FC<{ sport: Sport; sx?: any }> = ({ sport, sx }) => {
  const Icon = getSportIcon(sport);
  return <Icon sx={sx} />;
};
